import { FeatureFlagOptions, FeatureFlags } from ".";

export const defaultFeatureFlags: FeatureFlags = {
  WALLET: { treatment: "off", config: null },
  ADD_VEHICLE: { treatment: "base", config: null },
  REMOVE_VEHICLE: { treatment: "on", config: { max_vehicle_count: "10" } },
  SETTINGS_MFA_FOR_ALL: { treatment: "off", config: null },
  SELL_VEHICLE: { treatment: "off", config: null },
  ID_CARD_PAGE: { treatment: "off", config: null },
  PAPERLESS: { treatment: "off", config: null },
};

/** An array of all supported feature flags. */
export const featureFlagKeys = Object.keys(defaultFeatureFlags);

/**
 * Convert a featureFlags object into an array of strings formatted as "key:value"
 * ex: { INSURANCE: "new"} => ["INSURANCE:new"]
 */
export const formatFeatureFlagsForTracking = (
  featureFlags: FeatureFlags
): string[] => {
  return Object.entries(featureFlags).map(
    ([key, value]) => `${key}:${value.treatment}`
  );
};

export const defaultTestFeatureFlags = {
  WALLET: { treatment: "off", config: null },
  ADD_VEHICLE: { treatment: "base", config: null },
  REMOVE_VEHICLE: { treatment: "on", config: { max_vehicle_count: "10" } },
  SETTINGS_MFA_FOR_ALL: { treatment: "on", config: null },
  SELL_VEHICLE: { treatment: "on", config: null },
  ID_CARD_PAGE: { treatment: "off", config: null },
  PAPERLESS: { treatment: "on", config: null }
} as const;

export const BaseNewValues = ["base", "new"];
export const OnOffValues = ["off", "on"];

export const defaultWalletOptions: FeatureFlagOptions = {
  values: OnOffValues,
  defaultValue: "off",
  config: null,
} as const;

export const defaultAddVehicleOptions: FeatureFlagOptions = {
  values: BaseNewValues,
  defaultValue: "base",
  config: null,
} as const;

export const defaultRemoveVehicleOptions: FeatureFlagOptions = {
  values: OnOffValues,
  defaultValue: "on",
  config: { max_vehicle_count: "10" },
} as const;

export const defaultSettingsMfaForAllOptions: FeatureFlagOptions = {
  values: OnOffValues,
  defaultValue: "off",
  config: null,
} as const;

export const defaultSellVehicleOptions: FeatureFlagOptions = {
  values: OnOffValues,
  defaultValue: "off",
  config: null,
} as const;

export const defaultIdCardPageOptions: FeatureFlagOptions = {
  values: OnOffValues,
  defaultValue: "off",
  config: null,
} as const;

export const defaultPaperlessOptions: FeatureFlagOptions = {
  values: OnOffValues,
  defaultValue: "off",
  config: null,
} as const;
